import type {
  IncomingChallenge,
  OutgoingChallenge,
  OutgoingTeamLobbyInvite,
  PublicUser,
  TeamLobbyInvite,
} from "@mk/shared";

export interface FriendEntry {
  friendshipId: string;
  user: PublicUser;
  online: boolean;
  matchId: string | null;
  teamMatchId: string | null;
  teamMatchWatchable: boolean;
  record: { wins: number; losses: number; draws: number };
}

export interface FriendsData {
  friends: FriendEntry[];
  incoming: FriendEntry[];
  outgoing: FriendEntry[];
  challenges: IncomingChallenge[];
  sentChallenges: OutgoingChallenge[];
  teamInvites: TeamLobbyInvite[];
  sentTeamInvites: OutgoingTeamLobbyInvite[];
}

export const EMPTY_FRIENDS_DATA: FriendsData = {
  friends: [],
  incoming: [],
  outgoing: [],
  challenges: [],
  sentChallenges: [],
  teamInvites: [],
  sentTeamInvites: [],
};
